module.exports = __webpack_public_path__ + "static/img/vr1.0663e31.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vr/vr1.png
// module id = YoWI
// module chunks = 1